<template lang="html">

  <section class="opt_labels">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="opt_labels_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.opt_labels_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">CUSTPR Labels</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-10"
                ></b-pagination>                
              </div>              
            </div>
            <div class="col-lg-1">
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                 <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
            </div>
            <div class="col-lg-7">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.opt_labels_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-if="false"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-if="false"><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
             <b-row>
                   <carousel v-if="showOptImages" v-bind:images="imageList" v-bind:superScope="toggleShowOptImages" />
             </b-row>
            <b-table v-if="!showOptImages && curModel == 'DEFAULT'" ref="opt_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="default_fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->             
              <template  v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">
                  <a v-if="data.item.colGridList && data.item.colGridList.length" role="button" data-toggle="collapse" href="javascript:void(0);" v-b-modal.opt-color-details  @click="curItem=data.item.optItem; searchColors(data.item)" aria-expanded="true" aria-controls="collapseOne">
                    <i class="mdi mdi-open-in-new"></i>
                  </a>
                </h4>
                </b-row>
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(opt_icon)="data" lang="html">            
                <b-row>               
                  <b-button v-if="true" class="col-lg-5 p-1 m-auto color_img"  @click="curItem=data.item.optItem; showOptImagesCar(data.item.optItem)" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt">
                    <img :id="getCurrentModelId+'_'+data.item.optItem.group.code+'_'+data.item.optItem.code" class="color_img" @load="hideParent" :src="'/ccb/public/api/imageMapper/resized_repo/55/'+getCurrentModelId+'/'+data.item.optItem.group.code+'/'+data.item.optItem.code+'/menu_icon.jpg'"  border="0" />
                  </b-button>                 
                </b-row>
              </template>
               <template v-slot:cell(default_label)="data" lang="html">
                  <b-row>
                   <input type="text" id="default_opt_label" :value="getValueForDefaultOptLabel(data.item.optItem.optLabelList)" class="col-lg-10" />
                      
                  </b-row>
                </template>

              <template v-slot:cell(info_icon)="data" lang="html">             
                  <b-row>               
                    <b-button v-if="true" class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt info" @click="curItem=data.item; showInfo(curItem, curModel)" >
                     <i class="mdi mdi-information-outline"></i>
                    </b-button>                 
                  </b-row>
              </template>
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>   
                   <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" v-b-tooltip.hover title="Aggiorna Label" variant="primary" @click="curItem=data.item; askForUpdateDefaultLabel(curItem,curItem.optItem.optLabelList[0])">
                    <i class="mdi mdi-check-outline"></i>
                  </b-button>                          
                  <b-button v-if="curModel!='DEFAULT'" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" v-b-tooltip.hover title="Cancella la label per questo modello in tutte le lingue" variant="primary" @click="curItem=data.item.optItem;">
                    <i data-v-188347d3="" class="mdi mdi-cancel" ></i>
                  </b-button>     
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" v-b-tooltip.hover title="Cancella la label per questo modello in tutte le lingue" variant="primary" disabled>
                    <i data-v-188347d3="" class="mdi mdi-cancel" ></i>
                  </b-button>                     
                </b-row>
              </template>
            </b-table>
           <!-- -->
            <b-table v-if="!showOptImages && curModel != 'DEFAULT'" ref="opt_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="model_fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->             
              <template  v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">
                  <a v-if="data.item.colGridList && data.item.colGridList.length" role="button" data-toggle="collapse" href="javascript:void(0);" v-b-modal.opt-color-details  @click="curItem=data.item.optItem; searchColors(data.item)" aria-expanded="true" aria-controls="collapseOne">
                    <i class="mdi mdi-open-in-new"></i>
                  </a>
                </h4>
                </b-row>
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(opt_icon)="data" lang="html">            
                <b-row>               
                  <b-button v-if="true" class="col-lg-5 p-1 m-auto color_img"  @click="curItem=data.item.optItem; showOptImagesCar(data.item.optItem)" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt">
                    <img :id="getCurrentModelId+'_'+data.item.optItem.group.code+'_'+data.item.optItem.code" class="color_img" @load="hideParent" :src="'/ccb/public/api/imageMapper/resized_repo/55/'+getCurrentModelId+'/'+data.item.optItem.group.code+'/'+data.item.optItem.code+'/menu_icon.jpg'"  border="0" />
                  </b-button>                 
                </b-row>
              </template>

              <template v-slot:cell(info_icon)="data" lang="html">             
                  <b-row>               
                    <b-button v-if="true" class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt info" @click="curItem=data.item; showInfo(curItem, curModel)" >
                     <i class="mdi mdi-information-outline"></i>
                    </b-button>                 
                  </b-row>
              </template>
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Aggiorna Label" @click="curItem=data.item; askForUpdateLabel(data.item)">
                    <i class="mdi mdi-check-outline"></i>
                  </b-button>
                  <b-button v-if="curModel!='DEFAULT'" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" v-b-tooltip.hover title="Cancella la label per questo modello in tutte le lingue" variant="primary" @click="curItem=data.item.optItem;">
                    <i data-v-188347d3="" class="mdi mdi-cancel" ></i>
                  </b-button>     
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" v-b-tooltip.hover title="Cancella la label per questo modello in tutte le lingue" variant="primary" disabled>
                    <i data-v-188347d3="" class="mdi mdi-cancel" ></i>
                  </b-button>                  
                </b-row>
              </template>
              <template v-slot:cell(default_opt_label)="data" lang="html">
                  <b-row>
                    <input id="default_opt_label" disabled type="text" :value="getValueForDefaultOptLabel(data.item.optItem.optLabelList)" class="col-lg-10" />
                  </b-row>
                </template>  
              <template v-slot:cell(custom_model_label)="data" lang="html">                
                  <b-row>
                    <input id="modelLabel" type="text" :value="getValue(data.item.optItem.optLabelList)" class="col-lg-10" />
                  </b-row>
                </template>  
            </b-table>


           
            <b-modal id="opt-color-details" title="Opt Color Details" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                   <carousel v-if="showColorImages" v-bind:images="imageList" v-bind:superScope="toggleShowColorImages" />
                </b-row>
                <b-row>
                  <b-table v-if="!showColorImages" ref="opt_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="subItems" 
              :fields="Colorfields"
              :per-page="1000"
              :current-page="currentPage"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->

            <b-tooltip target="tooltip-target-1" triggers="hover">                    
            </b-tooltip>              
            <template v-slot:cell(color_icon)="data" lang="html">             
                <b-row>               
                  <b-button v-if="true" class="col-lg-5 p-1 m-auto color_img" @click="showColorImagesCar(data.item)" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt colore">
                    <img class="color_img" @load="hideParent" :src="'/ccb/public/api/imageMapper/resized_repo/55/'+getCurrentModelId+'/'+curItem.group.code+'/'+curItem.code+'/'+data.item.colItem.code+'/menu_icon.jpg'"  border="0" />
                  </b-button>                 
                </b-row>
            </template>
              <template v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">
                  <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="expandItem(data.item)" aria-expanded="true" aria-controls="collapseOne">
                    <i class="mdi mdi-open-in-new"></i>
                  </a>
                </h4>
                </b-row>
              </template>
            </b-table>
                </b-row>
             </b-container>
             <template v-slot:modal-footer="{ cancel }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="primary" v-if="!showColorImages" @click="cancel()">
                    Close
                  </b-button>
                </fragment>
              </template>
            </b-modal>      
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
.info_button {
  border-radius: 51%;
  padding: 0px !important;
  height: 2.5vw;
  margin: auto !important;
  text-align: center;
  float: left;
  margin-left: 0px !important;
}

.color_img {
  max-width: 2.875rem;
  border: 0px transparent dotted;
  padding: 0px !important;
  background: transparent;
}
.color_img img {
  border: 0px transparent dotted;
  padding: 0px !important;
  box-shadow: 0px -9px 7px -3px rgba(33, 33, 33, 0.8);
  background: transparent;
}

.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 15vw !important;
  overflow: hidden;
  word-break: break-all;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
import carousel from '../ui-components/carousel'
export default {
  name: 'opt_labels',
  components:{carousel},
  methods: {
    getValueForDefaultOptLabel(optLabelList){
    //se label per default non esiste passo campo a blank
    if (optLabelList[0]==undefined){
      return '';
    }
     return (optLabelList && optLabelList.length && optLabelList.length>1) ?
            ( (optLabelList[0].model.modelcode!='DEFAULT' ) ? optLabelList[1].label :optLabelList[0].label) : optLabelList[0].label;
    },
    getValue(optLabelList){
      return (optLabelList && optLabelList.length && optLabelList.length>1) ? 
                ( (optLabelList[0].model.modelcode!='DEFAULT' ) ? optLabelList[0].label : optLabelList[1].label) : '';
    },
    showInfo(curItem, model){
      this.setSpinnerStatus(true);
       this.axios
        .get('/ccb/auth/api/getConfGridByModelOptColor?optcode='+curItem.optItem.code+"&model="+model ,  {
        ...this.authHeader}          
          )
          .then((response) => {
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'pre',
                {
                  domProps: { innerHTML: response.data }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                  document.querySelector('.modal-dialog-centered').classList.add('scaled')  
                }, 10);               
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    toggleShowOptImages(){
        this.showOptImages = !this.showOptImages;
    },
    toggleShowColorImages(){
      this.showColorImages = !this.showColorImages;
    },
      showOptImagesCar(curOptItem){
      var imgRoot = this.getImgRoot;
      this.imageList  = []
      var scope = this;
      var maxX = 12 
      var curItem = this.curItem
      var color = curOptItem;    

        for(var i = 1; i <= 12; i++){
            var ph = imgRoot+this.getCurrentModelId+'/'+curItem.group.code+'/'+curItem.code+'/gfx'+i+'.png'
            var img = new Image();
            img.name='gfx'+i+'.png';
            img.onload = function(){
              
              if(this.width > 1)
                scope.imageList.push({src:this.src, name:this.name}); 
            }            
            img.src = ph;
          }          
         var infoImg = new Image();
          infoImg.name='info1400x875.jpg';
          infoImg.onload = function(){          
            if(this.width > 1)
              scope.imageList.push({src:this.src, name:this.name});          
          }
          
          infoImg.src = imgRoot+this.getCurrentModelId+'/'+curItem.group.code+'/'+curItem.code+'/info1400x875.jpg';
         
          this.showOptImages = true;
    },
    showColorImagesCar(curItemColor){
      var imgRoot = this.getImgRoot;
      this.imageList  = []
      var scope = this;
      var maxX = 12 
      var curItem = this.curItem
      var color = curItemColor;    


        for(var i = 1; i <= 12; i++){
            var ph = imgRoot+'repo/'+this.getCurrentModelId+'/'+curItem.group.code+'/'+curItem.code+'/'+color.colItem.code+'/gfx'+i+'.png'
            var img = new Image();
            img.name='gfx'+i+'.png';
            img.onload = function(){
              
              if(this.width > 1)
                scope.imageList.push({src:this.src, name:this.name}); 
            }            
            img.src = ph;
          }          
          
         var infoImg = new Image();
          infoImg.name='info1400x875.jpg';
          infoImg.onload = function(){          
            if(this.width > 1)
              scope.imageList.push({src:this.src, name:this.name});          
          }
          
          infoImg.src = imgRoot+this.getCurrentModelId+'/'+color.colItem.code+'/info1400x875.jpg';
         

          this.showColorImages = true;

    },
    getDefaultLabel(list){
      var lng = this.getCurLanguage;
      if(this.getCurModel != 'DEFAULT')
      return this.filterElementsByLanguageCodeAndModel(list,{language:lng, modelcode: this.getCurModel})
      else
      return [this.findDefaultElementByLanguageCode(list,lng)]
    },
    getDefaultLabel_(list){
      var lng = this.getCurLanguage;
      return this.filterElementsByLanguageCodeAndModel(list,{language:lng, modelcode: 'DEFAULT'})
    },
    expandItem(element){
      console.log(element)
      this.accordionManager()
    },
    hideParent(target){    
      var element = (!target.target) ? target.path[0] : target.target;
      var w = element.width
      if(!(w > 1)){
        element.parentNode.className = 'forceHide';
      }
    },
  accordionManager () {
    document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
      var tr = document.createElement('tr')
          tr.className = 'expandableContent closed';
      var td = document.createElement('td')
          td.setAttribute('colspan',6);
          td.style.backgroundColor = 'yellow';  

          tr.appendChild(td);
          el.parentNode.appendChild(tr);
          el.parentNode.insertBefore(el,tr)
    })
  },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value){
            this.setSpinnerStatus(true);
              this.axios
              .delete('/ccb/auth/fe/optGridLabel/' + item.id ,this.authHeader)
              .then(response => {
                this.setSpinnerStatus(false);
                this.$bvModal.msgBoxOk(response.data.message, {
                  okVariant: 'success',
                  hideHeaderClose: false,
                  centered: true
                })
                this.refreshTable()
                this.curItem=null
              })           
              .catch(error => {
                  this.$bvModal.msgBoxOk(error.message, {
                  okVariant: 'danger',
                  hideHeaderClose: false,
                  centered: true
                })
              }).finally(e=>{
                this.setSpinnerStatus(false);
              })
          }
        })
    },
    askForUpdateLabel(optItem){
      
      this.$bvModal.msgBoxConfirm('Vuoi Modificare '+optItem.optItem.code+'?', {
        title: 'Update Label',
        okVariant: 'warning',
        okTitle: 'Update',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.labelUpdate(optItem)
        }      
      })
      .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    labelUpdate(optGrid) { 
      this.setSpinnerStatus(true);
      window.curr = optGrid
      var value = this.$el.querySelector('#modelLabel').value
      if (optGrid.optItem.optLabelList.length>1){
        if (optGrid.optItem.optLabelList[0].model.modelcode!='DEFAULT'){
          var intLabObj =  optGrid.optItem.optLabelList[0];
        }
        else{
          var intLabObj =  optGrid.optItem.optLabelList[1];
        }
      }
      else{
        var intLabObj =  optGrid.optItem.optLabelList[0];
      }
      intLabObj.label = value
      this.axios
        .put('/ccb/auth/fe/optGridLabel/changeOptLabelInOptGrid/' + optGrid.id+'/' + this.getCurLanguage, intLabObj ,this.authHeader)
        .then(response => {
          if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
                this.refreshTable();  
              })
            }
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
            })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })
    }, 
    askForUpdateDefaultLabel(optGrid,optLabelListElement){
      this.$bvModal.msgBoxConfirm('Vuoi Modificare '+optGrid.optItem.code+'?', {
        title: 'Update Label',
        okVariant: 'warning',
        okTitle: 'Update',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.saveCurItem(optGrid,optLabelListElement)
        }      
      })
      .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
    },
    saveCurItem(optItem,curItem) {
      this.setSpinnerStatus(true);
      window.curr = curItem
      curItem.optItem = {id:optItem.id}
      var value = this.$el.querySelector('#default_opt_label').value;
      curItem.label=value;
      var intLabObj = curItem  
      this.axios
        .put('/ccb/auth/fe/optLabel/' + curItem.optItem.id, intLabObj ,this.authHeader)
        .then(response => {
          if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              this.refreshTable();
            }
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })
    },
    createItem() {
      //TODO salvare curItem
    
     var intLabObj = this.newItem     
      intLabObj.language = {id: this.getCurLanguageObj.id}
      this.axios
          .post('/ccb/auth/fe/optGridLabel', intLabObj, this.authHeader)
            .then(response => {
              //console.log("Response: '" + response.data + "' with Statuscode " + response.status);
              if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
               this.refreshTable();
              }
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
              // place the loginError state into our vuex store
            })
     
    },
   search() {
     this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
            optGroup: this.getCurLabelGroup, modelName: this.getCurModel, language: this.getCurLanguage, 
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/optGridLabel/findByOptGroupAndModelName' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
            window.datas = response.data;
            var content =  response.data.content;
            for(var x = 0; x < content.length; x++) {
              if(content[x].optItem.optLabelList.length) {
                 var translatedElement = this.getDefaultLabel(content[x].optItem.optLabelList);
                 content[x].optItem.optLabelList = translatedElement
              }             
            }     
          this.setSpinnerStatus(false);
          this.setInterfaceLabels(content)                   
         this.totalRowsResult=response.data.totalElements;           
          });
    }, 
    searchColors(currOptGrid) {     
      this.setSpinnerStatus(true);
      var params = {
            colGridId: currOptGrid.id }
      
      this.axios
      .get('/ccb/auth/fe/colGrid/findAllByGridId' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {         
            var content =  response.data;   
           
            for(var x = 0; x < content.length; x++) {
              if(content[x].colItem.colLabelList && content[x].colItem.colLabelList.length) {
               
                 var translatedElement = this.findElementByLanguageCode(content[x].colItem.colLabelList, this.getCurLanguage);
                  
                 content[x].colItem.colLabelList = translatedElement
              }
             
            }    

             currOptGrid.colGridList = content;
             this.curSubItem = currOptGrid;
             window.curSubItem = currOptGrid
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
        })
    }, 
    loadColors(currOptGrid) {     
      
      var params = {
            colGridId: currOptGrid.id }
      
      this.axios
      .get('/ccb/auth/fe/colGrid/findAllByGridId' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {         
            var content =  response.data;   
           
            for(var x = 0; x < content.length; x++) {
            //  console.log(content[x].colItem.colLabelList)
              if(content[x].colItem.colLabelList && content[x].colItem.colLabelList.length) {
               
                 var translatedElement = this.getDefaultLabel(content[x].colItem.colLabelList);
                  
                 content[x].colItem.colLabelList = translatedElement
              }
             
            }    

             currOptGrid.colGridList = content;
             this.curSubItem = currOptGrid;
             window.curSubItem = currOptGrid
          });
    },
    btnNew() {
      setTimeout(() => {
        var atG = this.getCurLabelGroup
        //document.querySelector('#labelGroup-dd').querySelector('option[value="'+atG+'"]').selected = true  
        this.newItem.optGroup = this.getCurLabelGroup;
      }, 300);
      
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setInterfaceLabels',
      'setSpinnerStatus',
      'setCurLabelGroup',
      'setCurrentModelId'
      
    ])
  },
  props: ['action','activeGroup'],
  data () {
    return {
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'optItem.code',
      sortDesc: false,
      curItem: null,
      curItemColor: null,
      curSubItem:null,
      showOptImages:false,
      showColorImages:false,
      imageList:[],
      newTranslation:'',
      newItem : {id:null, language: null,  optGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null},
      model_fields: [
       {
          key: 'accordionButton',
          label: '',
          sortable: false
        },
        {
          key: 'opt_icon',
          label: 'Icon',
          sortable: false
        },
        {
          key: 'optItem.code',
          label: 'Code',
          sortable: false
        },
        {
          key: 'info_icon',
          label: 'Info',
          sortable: false
        },
        {
          key: 'optItem.as400Description',
          label: 'as400 Label',
          sortable: false
        },
         {
          key: 'default_opt_label',
          label: 'Default Label',
          sortable: false
        },
        ,
         {
          key: 'custom_model_label',
          label: 'Model Label',
          sortable: false
        },
        {
          key: 'buttons',
          label: '',
          sortable: false
        }
      ],
      default_fields: [
        {
          key: 'accordionButton',
          label: '',
          sortable: false
        },
        {
          key: 'opt_icon',
          label: 'Icon',
          sortable: false
        },
        {
          key: 'optItem.code',
          label: 'Code',
          sortable: false
        },
        {
          key: 'info_icon',
          label: 'Info',
          sortable: false
        },
        {
          key: 'optItem.as400Description',
          label: 'as400 Label',
          sortable: false
        },
         {
          key: 'default_label',
          label: 'Default Label',
          sortable: false
        },
        {
          key: 'buttons',
          label: '',
          sortable: false
        }
      ],
       Colorfields: [
       
        {
          key: 'color_icon',
          label: 'Icon',
          sortable: false
        },
        {
          key: 'colItem.code',
          label: 'Code',
          sortable: false
        },        
        {
          key: 'colItem.as400Description',
          label: 'as400 Label',
          sortable: false
        },
         {
          key: 'colItem.colLabelList.label',
          label: 'Default Label',
          sortable: false
        },
        {
          key: 'buttons',
          label: '',
          sortable: false
        }
      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    items () {
      return (this.getInterfaceLabels && this.getInterfaceLabels.length) ? this.getInterfaceLabels : [];
    },
    subItems (){
       return (this.curSubItem && this.curSubItem.colGridList && this.curSubItem.colGridList.length) ? this.curSubItem.colGridList : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getInterfaceLabels',
      'getLabelGroupList',
      'getCurrentModelId',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getFullModelList',
      'getImgRoot'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {
    
    },
     currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this
    if(this.$route.query.activeGroup && this.$route.query.activeGroup !=null){
          this.setCurLabelGroup(this.$route.query.activeGroup);        
        }
       if(this.$route.query.action && this.$route.query.action === 'search'){
         
        this.search();        
       }
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
